/**
 * Exhaustiveness check for a discriminated union.
 *
 * `switch` with a `default` that returns a fallback compiles happily when a
 * new union member appears, and the fallback then reaches the user — a raw
 * provider name, a generic icon. Passing the value here instead makes the
 * omission a type error at the point it was forgotten, which is the only
 * thing that has reliably caught it.
 *
 * Throws if reached at runtime, which can only happen when data does not match
 * its declared type.
 */
export function assertNever(value: never): never {
  throw new Error(`unhandled variant: ${JSON.stringify(value)}`);
}
